import { ALERTS_CONTROL } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/types'
import { ORDER_ACTION_TYPE } from '@UI/crypto_exchange/desktop/pages/spot/components/SpotOrderTrade/components/types'

export const ALERT_TYPE_TABS = [
  { name: 'Sell', value: ORDER_ACTION_TYPE.SELL },
  { name: 'Buy', value: ORDER_ACTION_TYPE.BUY },
]
export const CREATED_ALERTS_TABS = [
  { name: 'Active', value: ALERTS_CONTROL.ACTIVE },
  { name: 'Triggered', value: ALERTS_CONTROL.TRIGGERED },
]
